<template>
    <div class="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-4 sm:p-6 lg:p-8">
      <div class="bg-white p-4 sm:p-6 lg:p-8 rounded-lg shadow-lg w-full max-w-md">
        <h2 class="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 text-gray-800">Login</h2>
        <form @submit.prevent="login" class="flex flex-col space-y-4">
          <input v-model="credentials.login"
                 class="w-full p-2 sm:p-3 border rounded-lg focus:outline-none focus:border-green"
                 placeholder="Phone"
                 required />
          <input type="password" v-model="credentials.password"
                 class="w-full p-2 sm:p-3 border rounded-lg focus:outline-none focus:border-green"
                 placeholder="Password"
                 required />
          <button type="submit"
                  class="bg-green text-white p-2 sm:p-3 rounded-lg hover:bg-green w-full">
            Login
          </button>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions } from 'vuex';
  import { useRouter } from 'vue-router';
  //import VueJwtDecode from 'vue-jwt-decode';
  export default {
    data() {
      return {
         router : useRouter(),
        credentials: {
          login: '',
          password: '',
        },
      };
    },
   
    mounted() {
    
   },
    methods: {
      ...mapActions('auth', {
        loginUser : 'loginUser'
      }),
      async login() {
        try {
          await this.loginUser(this.credentials);
          this.router.push('/home');
        } catch (error) {
          console.error('Login failed:', error);
          //alert('Invalid credentials. Please try again.');
        }
      },
    },
  };
  </script>
  